import * as React from "react";

import { FormContext } from "../contexts";

/**
 * `useForm()`
 */
function useForm() {
	return React.useContext(FormContext);
}

export { useForm };
